import { render, staticRenderFns } from "./OrderBasicInfo.vue?vue&type=template&id=17112bae&scoped=true&"
import script from "./OrderBasicInfo.vue?vue&type=script&lang=js&"
export * from "./OrderBasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./OrderBasicInfo.vue?vue&type=style&index=0&id=17112bae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17112bae",
  null
  
)

export default component.exports